module.exports = __webpack_public_path__ + "static/media/eslint-logo.3574b359.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/presentations/modern-javascript/assets/eslint-logo.jpg
// module id = 677
// module chunks = 0